import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
// import ReactGA from "react-ga";

// Components
import AppHelmet from "./AppHelmet";
import Notices from "./Notices";
import Header from "./Header";
import Body from "./Body";
import Footer from "./Footer";

// State
import { getSiteInfo } from "../store/actions/siteInfo";

// CSS
import "../css/general.css";

import { setGoogleAnalyticsEnvironment } from "../utils/google-analytics";

class App extends Component {
	initialAction() {
		this.props.getSiteInfo();
	}

	componentWillMount() {
		// On client and site info has not been fetched yet
		if (this.props.siteInfo.site === undefined) {
			this.initialAction();
		}

		if (typeof window !== "undefined") {
			setGoogleAnalyticsEnvironment(this.props.location.pathname);
		}
	}

	componentDidMount() {
		if (typeof window !== "undefined") {
			setGoogleAnalyticsEnvironment(this.props.location.pathname);
		}
	}

	render() {
		const route = this.props.location.pathname;

		return route === "/image-browser" || route === "/file-browser" ? (
			<Body />
		) : (
			<div>
				{/* <AppHelmet {...this.props} /> */}
				<Notices />
				<div className="body">
					<Header />
					<Body />
				</div>
				<Footer />
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		siteInfo: state.siteInfo,
		user: state.user
	};
};

const mapDispatchToProps = dispatch => {
	return {
		getSiteInfo: () => dispatch(getSiteInfo())
	};
};

export default withRouter(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(App)
);



// WEBPACK FOOTER //
// ./src/components/App.js